<template>
  <div>
    <v-dialog
      v-model="dialog"
      width="500"
      overlay-color="rgba(39, 50, 64)"
      overlay-opacity="0.6"
      :fullscreen="$vuetify.breakpoint.xs ? true : false"
      persistent
    >
      <v-card>
        <v-card-title class="header info">
          {{ $t('packs.upgradePack') }}
        </v-card-title>
        <v-card-text class="mt-4">
          {{ $t('packs.needPack') }}
        </v-card-text>
        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            class="success"
            @click="go()"
          >
            {{ $t('packs.upgradePack') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <upgrade-from-free
      v-if="upgradeDialog"
      :show-dialog="upgradeDialog"
      @closeUpgradeDialog="closeUpgradeDialog"
    />
  </div>
</template>

<script>

import UpgradeFromFree from "@/views/Packs/partial/UpgradeFromFree.vue"
import { mapGetters } from "vuex";

export default {
  name: 'HelperBuyPacks',
  components: {
    UpgradeFromFree
  },
  data: () => ({
    dialog: false,
    upgradeDialog: false,
  }),
  computed: {
    ...mapGetters("invoice", ["getPending"]),
  },
  methods: {
    open() {
      this.dialog = true;
    },
    go() {
      this.dialog = false
      this.upgradeDialog = true
    },
    closeUpgradeDialog() {
      this.upgradeDialog = false
      if (this.getPending != null) {
        this.$router.push(`/invoice/${this.getPending}`)
      }
    }
  }

}
</script>

<style lang="scss" scoped>
</style>
